"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentChannelType = exports.EPaymentLaunch = exports.ESpecStyle = exports.EPaymentSpecAction = void 0;
var EPaymentSpecAction;
(function (EPaymentSpecAction) {
    EPaymentSpecAction[EPaymentSpecAction["Unknown"] = 0] = "Unknown";
    EPaymentSpecAction[EPaymentSpecAction["Shuffle"] = 1] = "Shuffle";
    EPaymentSpecAction[EPaymentSpecAction["ShuffleByDep"] = 2] = "ShuffleByDep";
})(EPaymentSpecAction || (exports.EPaymentSpecAction = EPaymentSpecAction = {}));
var ESpecStyle;
(function (ESpecStyle) {
    ESpecStyle[ESpecStyle["Unknown"] = 0] = "Unknown";
    ESpecStyle[ESpecStyle["Fast"] = 1] = "Fast";
})(ESpecStyle || (exports.ESpecStyle = ESpecStyle = {}));
var EPaymentLaunch;
(function (EPaymentLaunch) {
    EPaymentLaunch[EPaymentLaunch["Frame"] = 1] = "Frame";
    EPaymentLaunch[EPaymentLaunch["Redirect"] = 2] = "Redirect";
    EPaymentLaunch[EPaymentLaunch["Qr"] = 3] = "Qr";
})(EPaymentLaunch || (exports.EPaymentLaunch = EPaymentLaunch = {}));
var PaymentChannelType;
(function (PaymentChannelType) {
    // new Cripto
    PaymentChannelType[PaymentChannelType["BTC"] = 1] = "BTC";
    PaymentChannelType[PaymentChannelType["LTC"] = 2] = "LTC";
    PaymentChannelType[PaymentChannelType["BCH"] = 3] = "BCH";
    PaymentChannelType[PaymentChannelType["ADA"] = 4] = "ADA";
    PaymentChannelType[PaymentChannelType["ETH"] = 5] = "ETH";
    PaymentChannelType[PaymentChannelType["DOGE"] = 6] = "DOGE";
    PaymentChannelType[PaymentChannelType["XRP"] = 7] = "XRP";
    PaymentChannelType[PaymentChannelType["USDTE"] = 9] = "USDTE";
    PaymentChannelType[PaymentChannelType["USDTT"] = 10] = "USDTT";
    PaymentChannelType[PaymentChannelType["BNB"] = 11] = "BNB";
    PaymentChannelType[PaymentChannelType["BNBBSC"] = 13] = "BNBBSC";
    PaymentChannelType[PaymentChannelType["BUSD"] = 14] = "BUSD";
    PaymentChannelType[PaymentChannelType["USDC"] = 17] = "USDC";
    PaymentChannelType[PaymentChannelType["TRX"] = 18] = "TRX";
    PaymentChannelType[PaymentChannelType["DAI"] = 20] = "DAI";
    // End new Cripto
    // TUrkishMPay
    PaymentChannelType[PaymentChannelType["MPayParazula"] = 26] = "MPayParazula";
    PaymentChannelType[PaymentChannelType["MPayPayco"] = 27] = "MPayPayco";
    PaymentChannelType[PaymentChannelType["MPayVCC"] = 28] = "MPayVCC";
    // RUB
    PaymentChannelType[PaymentChannelType["CreditCard"] = 29] = "CreditCard";
    PaymentChannelType[PaymentChannelType["CreditCardFast"] = 30] = "CreditCardFast";
    PaymentChannelType[PaymentChannelType["CreditCardAcquirning"] = 31] = "CreditCardAcquirning";
    PaymentChannelType[PaymentChannelType["VivaroBkash"] = 32] = "VivaroBkash";
    // END RUN
    PaymentChannelType[PaymentChannelType["BKash"] = 41] = "BKash";
    PaymentChannelType[PaymentChannelType["Nagad"] = 42] = "Nagad";
    PaymentChannelType[PaymentChannelType["VivaroNagad"] = 43] = "VivaroNagad";
    PaymentChannelType[PaymentChannelType["BKashFastWellexPayCopy"] = 62] = "BKashFastWellexPayCopy";
    PaymentChannelType[PaymentChannelType["NagadFastWellexPayCopy"] = 63] = "NagadFastWellexPayCopy";
    PaymentChannelType[PaymentChannelType["ApayNagad"] = 64] = "ApayNagad";
    PaymentChannelType[PaymentChannelType["NagadCashX"] = 65] = "NagadCashX";
    PaymentChannelType[PaymentChannelType["BkashXoomPay"] = 69] = "BkashXoomPay";
    PaymentChannelType[PaymentChannelType["BkashCashX"] = 70] = "BkashCashX";
    PaymentChannelType[PaymentChannelType["WithdrawRubSber"] = 71] = "WithdrawRubSber";
    PaymentChannelType[PaymentChannelType["WithdrawRubTinkof"] = 72] = "WithdrawRubTinkof";
    PaymentChannelType[PaymentChannelType["BKashFastWellexPay"] = 75] = "BKashFastWellexPay";
    // ------------------------ DEPOSITS ------------------------ MOVE TO UP
    PaymentChannelType[PaymentChannelType["NagadFastWellexPay"] = 76] = "NagadFastWellexPay";
    PaymentChannelType[PaymentChannelType["NagadWellexPay"] = 77] = "NagadWellexPay";
    PaymentChannelType[PaymentChannelType["BkashWellexPay"] = 78] = "BkashWellexPay";
    PaymentChannelType[PaymentChannelType["WellxpayUpay"] = 79] = "WellxpayUpay";
    PaymentChannelType[PaymentChannelType["WellxpayRocket"] = 80] = "WellxpayRocket";
    // Pakistan
    PaymentChannelType[PaymentChannelType["EasypaisaFast"] = 86] = "EasypaisaFast";
    PaymentChannelType[PaymentChannelType["Easypaisa"] = 87] = "Easypaisa";
    PaymentChannelType[PaymentChannelType["JazzCash"] = 88] = "JazzCash";
    PaymentChannelType[PaymentChannelType["NagadXoomPay"] = 89] = "NagadXoomPay";
    //MPay
    PaymentChannelType[PaymentChannelType["PaparaMPay"] = 91] = "PaparaMPay";
    PaymentChannelType[PaymentChannelType["EFTMPay"] = 92] = "EFTMPay";
    PaymentChannelType[PaymentChannelType["MiniHavaleMpay"] = 93] = "MiniHavaleMpay";
    PaymentChannelType[PaymentChannelType["MefeteMpay"] = 94] = "MefeteMpay";
    PaymentChannelType[PaymentChannelType["MefeteMpayQr"] = 95] = "MefeteMpayQr";
    PaymentChannelType[PaymentChannelType["PopyMpay"] = 97] = "PopyMpay";
    //  - Mpay end ( not full )
    PaymentChannelType[PaymentChannelType["Rocket"] = 103] = "Rocket";
    PaymentChannelType[PaymentChannelType["BkashMonetics"] = 126] = "BkashMonetics";
    PaymentChannelType[PaymentChannelType["NagadMonetics"] = 127] = "NagadMonetics";
    PaymentChannelType[PaymentChannelType["OctopayNagad"] = 134] = "OctopayNagad";
    PaymentChannelType[PaymentChannelType["OctopayBKash"] = 135] = "OctopayBKash";
    PaymentChannelType[PaymentChannelType["OctopayUPay"] = 136] = "OctopayUPay";
    PaymentChannelType[PaymentChannelType["OctopayRocket"] = 137] = "OctopayRocket";
    PaymentChannelType[PaymentChannelType["ApayBkash"] = 138] = "ApayBkash";
    PaymentChannelType[PaymentChannelType["UPay"] = 139] = "UPay";
    // INR payments
    PaymentChannelType[PaymentChannelType["INRIMPS"] = 140] = "INRIMPS";
    PaymentChannelType[PaymentChannelType["INRNEFTS"] = 141] = "INRNEFTS";
    PaymentChannelType[PaymentChannelType["INRRGTS"] = 142] = "INRRGTS";
    PaymentChannelType[PaymentChannelType["InrDeposit"] = 144] = "InrDeposit";
    PaymentChannelType[PaymentChannelType["INRWithdrawImp"] = 147] = "INRWithdrawImp";
    PaymentChannelType[PaymentChannelType["MPayCC"] = 148] = "MPayCC";
    PaymentChannelType[PaymentChannelType["MPayFix"] = 149] = "MPayFix";
    PaymentChannelType[PaymentChannelType["PagsmileBoleto"] = 152] = "PagsmileBoleto";
    PaymentChannelType[PaymentChannelType["PagsmileDepositExpress"] = 153] = "PagsmileDepositExpress";
    PaymentChannelType[PaymentChannelType["Lottery"] = 154] = "Lottery";
    PaymentChannelType[PaymentChannelType["PagsmileWalletPicPay"] = 155] = "PagsmileWalletPicPay";
    PaymentChannelType[PaymentChannelType["WalletAme"] = 156] = "WalletAme";
    PaymentChannelType[PaymentChannelType["PixPagsmile"] = 158] = "PixPagsmile";
    // USDT = 188,
    PaymentChannelType[PaymentChannelType["BankTransfer"] = 176] = "BankTransfer";
    PaymentChannelType[PaymentChannelType["NagadApi"] = 180] = "NagadApi";
    PaymentChannelType[PaymentChannelType["INRUpiFast"] = 182] = "INRUpiFast";
    PaymentChannelType[PaymentChannelType["PKRCashmaal"] = 183] = "PKRCashmaal";
    // Turkish
    PaymentChannelType[PaymentChannelType["AnindaHavale"] = 184] = "AnindaHavale";
    PaymentChannelType[PaymentChannelType["HavaleHera"] = 185] = "HavaleHera";
    PaymentChannelType[PaymentChannelType["VipHavale"] = 190] = "VipHavale";
    PaymentChannelType[PaymentChannelType["TurkishPapara"] = 191] = "TurkishPapara";
    PaymentChannelType[PaymentChannelType["TurkishCreditDebit"] = 192] = "TurkishCreditDebit";
    PaymentChannelType[PaymentChannelType["TurkishMefete"] = 193] = "TurkishMefete";
    PaymentChannelType[PaymentChannelType["TurkishExpressHavale"] = 194] = "TurkishExpressHavale";
    PaymentChannelType[PaymentChannelType["TurkishCepBank"] = 196] = "TurkishCepBank";
    PaymentChannelType[PaymentChannelType["TurkishPayFix"] = 198] = "TurkishPayFix";
    PaymentChannelType[PaymentChannelType["Pix"] = 201] = "Pix";
    PaymentChannelType[PaymentChannelType["BankPix"] = 202] = "BankPix";
    PaymentChannelType[PaymentChannelType["PlixopayPayco"] = 205] = "PlixopayPayco";
    PaymentChannelType[PaymentChannelType["PlixopayFast"] = 206] = "PlixopayFast";
    PaymentChannelType[PaymentChannelType["PlixopayPaybol"] = 207] = "PlixopayPaybol";
    PaymentChannelType[PaymentChannelType["PlixopayPaypay"] = 208] = "PlixopayPaypay";
    PaymentChannelType[PaymentChannelType["PlixopayPapara"] = 210] = "PlixopayPapara";
    PaymentChannelType[PaymentChannelType["BKashFast"] = 211] = "BKashFast";
    // PKR
    PaymentChannelType[PaymentChannelType["PKRJazzcash"] = 212] = "PKRJazzcash";
    PaymentChannelType[PaymentChannelType["PlixopayPopypara"] = 213] = "PlixopayPopypara";
    PaymentChannelType[PaymentChannelType["KodakUpi"] = 214] = "KodakUpi";
    PaymentChannelType[PaymentChannelType["KodakImpus"] = 215] = "KodakImpus";
    PaymentChannelType[PaymentChannelType["PKREasypaisa"] = 216] = "PKREasypaisa";
    PaymentChannelType[PaymentChannelType["MNXSpei"] = 217] = "MNXSpei";
    PaymentChannelType[PaymentChannelType["GLDNBKash"] = 218] = "GLDNBKash";
    PaymentChannelType[PaymentChannelType["Spei"] = 219] = "Spei";
    PaymentChannelType[PaymentChannelType["CoDi"] = 220] = "CoDi";
    PaymentChannelType[PaymentChannelType["Oxxo"] = 221] = "Oxxo";
    PaymentChannelType[PaymentChannelType["BankTransferTwo"] = 222] = "BankTransferTwo";
    PaymentChannelType[PaymentChannelType["NagadGldn"] = 223] = "NagadGldn";
    PaymentChannelType[PaymentChannelType["PlixopayParaparola"] = 224] = "PlixopayParaparola";
    PaymentChannelType[PaymentChannelType["CashXAZN"] = 225] = "CashXAZN";
    PaymentChannelType[PaymentChannelType["PlixoBKash"] = 226] = "PlixoBKash";
    PaymentChannelType[PaymentChannelType["PlixoNagad"] = 227] = "PlixoNagad";
    PaymentChannelType[PaymentChannelType["UpiP2p"] = 228] = "UpiP2p";
    PaymentChannelType[PaymentChannelType["PayTmP2P"] = 229] = "PayTmP2P";
    PaymentChannelType[PaymentChannelType["PhonePeP2P"] = 230] = "PhonePeP2P";
    PaymentChannelType[PaymentChannelType["NetBanking"] = 231] = "NetBanking";
    PaymentChannelType[PaymentChannelType["UPI"] = 232] = "UPI";
    PaymentChannelType[PaymentChannelType["UPI_QR"] = 233] = "UPI_QR";
    PaymentChannelType[PaymentChannelType["PlixoInrLocalPay"] = 234] = "PlixoInrLocalPay";
    PaymentChannelType[PaymentChannelType["PlixoInrP2p"] = 235] = "PlixoInrP2p";
    PaymentChannelType[PaymentChannelType["PlixoInrBank"] = 236] = "PlixoInrBank";
    PaymentChannelType[PaymentChannelType["PlixoAznCard"] = 237] = "PlixoAznCard";
    PaymentChannelType[PaymentChannelType["PlixoAznM10"] = 238] = "PlixoAznM10";
    PaymentChannelType[PaymentChannelType["PlixoAznMPay"] = 239] = "PlixoAznMPay";
    PaymentChannelType[PaymentChannelType["PlixoBdtBkash"] = 240] = "PlixoBdtBkash";
    PaymentChannelType[PaymentChannelType["PlixoNagadBkashSecond"] = 241] = "PlixoNagadBkashSecond";
    PaymentChannelType[PaymentChannelType["APayJazzcashP2C"] = 242] = "APayJazzcashP2C";
    PaymentChannelType[PaymentChannelType["APayNayapayP2P"] = 243] = "APayNayapayP2P";
    PaymentChannelType[PaymentChannelType["APayBankalfalahP2C"] = 244] = "APayBankalfalahP2C";
    PaymentChannelType[PaymentChannelType["APayBankTransfer"] = 245] = "APayBankTransfer";
    PaymentChannelType[PaymentChannelType["PKRPlixoEasypaisa"] = 246] = "PKRPlixoEasypaisa";
    PaymentChannelType[PaymentChannelType["PKRPlixoJazzCash"] = 247] = "PKRPlixoJazzCash";
    PaymentChannelType[PaymentChannelType["PlixoCreedoBkash"] = 248] = "PlixoCreedoBkash";
    PaymentChannelType[PaymentChannelType["PlixoCreedoNagad"] = 249] = "PlixoCreedoNagad";
    PaymentChannelType[PaymentChannelType["PlixoCreedoEasyPaisa"] = 250] = "PlixoCreedoEasyPaisa";
    PaymentChannelType[PaymentChannelType["PlixoCreedoJazzCash"] = 251] = "PlixoCreedoJazzCash";
    PaymentChannelType[PaymentChannelType["FluxBKash"] = 252] = "FluxBKash";
    PaymentChannelType[PaymentChannelType["FluxNagad"] = 253] = "FluxNagad";
})(PaymentChannelType || (exports.PaymentChannelType = PaymentChannelType = {}));
